module.exports = __webpack_public_path__ + "img/yizhanshi2.ef7e637d.png";